import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-img',
    standalone: false,
    templateUrl: './img.component.html',
    styleUrl: './img.component.scss'
})
export class ImgComponent {
    /** Ruta de la imagen (assets/) */
    @Input() src!: string;
    /** Ancho en px al que se renderizará */
    @Input() width!: number;
    /** Alto en px al que se renderizará */
    @Input() height!: number;
    /** Texto alternativo */
    @Input() alt = '';
    /** Si es true, marca prioridad LCP */
    @Input() priority = false;
    /** Clases CSS adicionales para el <img> (ej. 'object-contain') */
    @Input() imgClass = '';
}
